import { render, staticRenderFns } from "./HeaderInfoSection.vue?vue&type=template&id=871e0222&scoped=true"
import script from "./HeaderInfoSection.vue?vue&type=script&lang=js"
export * from "./HeaderInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e0222",
  null
  
)

export default component.exports